__turbopack_context__.v({
  "actions": "CartItems-module__LhZuva__actions",
  "details": "CartItems-module__LhZuva__details",
  "imageContainer": "CartItems-module__LhZuva__imageContainer",
  "info": "CartItems-module__LhZuva__info",
  "item": "CartItems-module__LhZuva__item",
  "itemsList": "CartItems-module__LhZuva__itemsList",
  "name": "CartItems-module__LhZuva__name",
  "price": "CartItems-module__LhZuva__price",
  "quantity": "CartItems-module__LhZuva__quantity",
  "quantityBtn": "CartItems-module__LhZuva__quantityBtn",
  "quantityValue": "CartItems-module__LhZuva__quantityValue",
  "removeBtn": "CartItems-module__LhZuva__removeBtn",
  "variant": "CartItems-module__LhZuva__variant",
});
